import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ICustomer, IUser, IUserForSettingsView } from 'app/models';
import { IAuthority } from 'app/models/authority.model';
import { CustomerService } from 'app/services';
import { UserService } from 'app/services';
import { MessageService } from 'app/services/message/message.service';
import { Observable } from 'rxjs';
import {
  ConfirmDialogModel,
  ConfirmDialogComponent,
} from '../confirm-dialog/confirm-dialog.component';
import { AbstractSettingsFilteredTableComponent } from '../setting-mngt-filtered-table';
import { UserMngtDetailComponent } from '../user-mngt-detail/user-mngt-detail.component';

@Component({
  selector: 'app-user-mngt',
  templateUrl: './user-mngt.component.html',
  styleUrls: ['./user-mngt.component.scss'],
})
export class UserMngtComponent extends AbstractSettingsFilteredTableComponent<IUserForSettingsView> implements OnInit {
  @ViewChild(UserMngtDetailComponent)
  private userMngtDetailComponent!: UserMngtDetailComponent;

  customers: ICustomer[] = [];
  authorities: IAuthority[] = [];
  displayedColumns = [
    'username',
    'customer',
    'enabled',
    'unit',
    'email',
    'roles',
    'Actions',
  ];

  result = '';

  dataSource = new MatTableDataSource<IUserForSettingsView>();

  constructor(
    private userService: UserService,
    private customerService: CustomerService,
    public dialog: MatDialog,
    private messageService: MessageService
  ) {
    super();
  }

  ngOnInit() {
    this.getCustomers();
    this.getIUsers();
  }

  onUserSaved(saved: boolean) {
    const msg: string = saved
      ? ` User correctly saved `
      : ` User NOT correctly saved `;
    this.messageService.showDirectSimpleMessage(msg);
    this.getIUsers();
  }

  getIUsers(): void {
    this.userService.getIUsers().subscribe(
      (users) => {
        const viewUsers: IUserForSettingsView[] = users.map(
          currentUser => {
            (currentUser as IUserForSettingsView).customerName = this.getCustomerById(currentUser.customerId)?.name;
            return currentUser;
          }
        );
        this.dataSource.data = viewUsers.sort(
          (a, b) => {
            if (! a.customerName || !b.customerName ) { return 1; }
            return (a.customerName < b.customerName ) ? -1 : 1;
          });
      },
      () => this.messageService.showDirectSimpleMessage(` Loading users error `)
    );
  }

  getCustomers(): void {
    this.customerService.findAllCustomers().subscribe(
      (customers) => (this.customers = customers.sort((a, b) => (a.name < b.name) ? -1 : 1)),
      () =>
        this.messageService.showDirectSimpleMessage(` Loading customer error `)
    );
  }

  getCustomerById(id: number): ICustomer | undefined {
    return this.customers.find((item) => item.id === id);
  }

  delete(user: IUser): Observable<IUser> {
    return this.userService.deleteIUser(user.id);
  }

  deleteConfirmDialog(userToBeDeleted: IUser): void {
    const message = `Are you sure you want to delete the user with username ${userToBeDeleted.username} ?`;
    const dialogData = new ConfirmDialogModel('Confirm Delete Action', message);

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: dialogData,
    });

    dialogRef.afterClosed().subscribe((dialogResult) => {
      this.result = dialogResult;
      if (dialogResult) {
        this.delete(userToBeDeleted).subscribe(
          () => this.messageService.showDirectSimpleMessage(` User deleted `),
          () =>
            this.messageService.showDirectSimpleMessage(` User delete error `),
          () => this.getIUsers() //update user list
        );
      }
    });
  }

  generatePwd(user: IUser): Observable<IUser> {
    return this.userService.generatePwd(user.id);
  }

  generatePwdConfirmDialog(userToGeneratePwd: IUser): void {
    const message = `Are you sure you want to generate a new password for the user wirh username ${userToGeneratePwd.username} ?`;
    const dialogData = new ConfirmDialogModel(
      'Confirm Generate Password Action',
      message
    );

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: dialogData,
    });

    dialogRef.afterClosed().subscribe((dialogResult) => {
      this.result = dialogResult;
      if (dialogResult) {
        this.generatePwd(userToGeneratePwd).subscribe(
          () => this.messageService.showDirectSimpleMessage(` Pwd generated `),
          () =>
            this.messageService.showDirectSimpleMessage(
              ` Pwd generation error `
            )
        );
      }
    });
  }

  edit(user: IUser): void {
    this.userMngtDetailComponent.initEdit(user);
  }
}
